module.exports = __webpack_public_path__ + "static/media/jenkins.b2527f01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jenkins.svg
// module id = 534
// module chunks = 0